// Thai first (root AGENTS.md, packages/ui/DESIGN.md: "ไทยคือภาษาหลักของผู้ใช้"), English as the
// secondary technical label. No framework — a plain dictionary keyed the same in both languages.

export type Lang = "th" | "en";

export const STRINGS = {
  title: { th: "คลังมัลติมีเดีย PREEDA NEXT", en: "PREEDA NEXT media library" },
  subtitle: {
    th: "ตรา ภาพ วิดีโอ โมเดลสามมิติ และเอกสาร — จากถังกลางเดียวที่ทุกเว็บในเครือใช้ร่วมกัน",
    en: "Marks, images, video, 3D and documents — from the one central bucket every site shares",
  },
  searchPlaceholder: {
    th: "ค้นชื่อไฟล์หรือชื่อในโค้ด",
    en: "Search a file name or a code name",
  },
  filterBrand: { th: "แบรนด์", en: "Brand" },
  filterAll: { th: "ทั้งหมด", en: "All" },
  measuredAt: { th: "วัดจากถังจริงเมื่อ", en: "measured from the live bucket at" },
  notMeasured: {
    th: "ยังไม่ได้อ่านจากถังจริง — ค่าจากโค้ดเท่านั้น",
    en: "not read from the live bucket — code registries only",
  },
  itemsCount: { th: "รายการ", en: "items" },
  empty: { th: "ยังไม่มีไฟล์ในหมวดนี้", en: "Nothing here yet" },
  download: { th: "ดาวน์โหลด", en: "Download" },
  copyUrl: { th: "คัดลอกที่อยู่", en: "Copy URL" },
  copied: { th: "คัดลอกแล้ว", en: "Copied" },
  open: { th: "เปิด", en: "Open" },
  close: { th: "ปิด", en: "Close" },
  credit: { th: "เครดิต", en: "Credit" },
  licence: { th: "สัญญาอนุญาต", en: "Licence" },
  loadModel: { th: "โหลดโมเดล", en: "Load the model" },
  loadingModel: { th: "กำลังโหลดโมเดล…", en: "Loading the model…" },
  modelFailed: { th: "โหลดโมเดลไม่สำเร็จ", en: "The model did not load" },
  loadingFont: { th: "กำลังโหลดฟอนต์…", en: "Loading the font…" },
  fontFailed: { th: "โหลดฟอนต์ไม่สำเร็จที่นี่", en: "The font did not load here" },
  section_mark: { th: "แบรนด์", en: "Brand" },
  section_image: { th: "ภาพ", en: "Images" },
  section_video: { th: "วิดีโอ", en: "Video" },
  section_model: { th: "โมเดลสามมิติ", en: "3D" },
  section_document: { th: "เอกสาร", en: "Documents" },
  section_audio: { th: "เสียง", en: "Audio" },
  colorsHeading: { th: "สีของแต่ละแบรนด์", en: "Colour per brand" },
  fontsHeading: { th: "ตัวอย่างฟอนต์", en: "Type specimens" },
  bytes: { th: "ไบต์", en: "bytes" },
} as const;

export type StringKey = keyof typeof STRINGS;

const STORAGE_KEY = "pnx-assets-lang";

export function readLang(): Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "th" || stored === "en") return stored;
  } catch {
    // localStorage can throw in a locked-down preview; fall back below.
  }
  return "th";
}

export function writeLang(lang: Lang): void {
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    // best-effort only — a viewer's language choice not persisting is not worth surfacing
  }
}

export function t(key: StringKey, lang: Lang): string {
  return STRINGS[key][lang];
}
